export const TSCONFIG = 'tsconfig.json'
export const BANNER = `// GENERATED via 'vite-plugin-tsconfig' - this should be automatically created and deleted inside the build process. \n`
export const BAK = 'bak.vite-plugin-tsconfig'
